import * as React from 'react';

import { motion } from 'framer-motion';

import styled, { useTheme } from 'styled-components';

export interface CloseIconProps {
  className?: string;
  size?: number;
  noBg?: boolean;
  noHover?: boolean;
  isInvertedColor?: boolean;
  isDark?: boolean;
  isWhite?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const CloseIcon: React.FC<CloseIconProps> = (props) => {
  const theme = useTheme();

  const rotate = {
    rest: {
      rotate: 0,
      opacity: 1,
    },
    hover: {
      rotate: 90,
      transition: {
        ease: [0.0, 0.0, 0.25, 1.0],
        duration: 0.15,
      },
    },
    click: {
      opacity: 0,
    },
  };

  const getBgCircleColor = (
    isInvertedColor?: boolean,
    isDark?: boolean,
    isWhite?: boolean
  ) => {
    if (isInvertedColor) {
      return theme.colors.primaryHover;
    }
    if (isDark) {
      return theme.colors.blackActive;
    }
    if (isWhite) {
      return theme.colors.differentBackground;
    }
    return theme.colors.secondary;
  };

  const getLines = (isInvertedColor?: boolean, isDark?: boolean) => {
    if (isInvertedColor) {
      return theme.colors.background;
    }
    if (isDark) {
      return theme.colors.white;
    }
    return theme.colors.primaryHover;
  };

  return (
    <motion.svg
      width={props.size}
      height={props.size}
      viewBox="0 0 40 40"
      className={props.className}
      initial="rest"
      whileHover={props.noHover ? 'rest' : 'hover'}
      whileTap="hover"
      animate="rest"
      exit="click"
      onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
    >
      {!props.noBg && (
        <circle
          fill={getBgCircleColor(
            props.isInvertedColor,
            props.isDark,
            props.isWhite
          )}
          cx="20"
          cy="20"
          r="20"
        />
      )}
      <motion.path
        variants={rotate}
        fill={getLines(props.isInvertedColor, props.isDark)}
        d="M15.8 14.3l9.9 9.9c0.4 0.4 0.4 1 0 1.4 -0.4 0.4-1 0.4-1.4 0l-9.9-9.9c-0.4-0.4-0.4-1 0-1.4C14.7 14 15.4 14 15.8 14.3z"
      />
      <motion.path
        variants={rotate}
        fill={getLines(props.isInvertedColor, props.isDark)}
        d="M24.2 14.3l-9.9 9.9c-0.4 0.4-0.4 1 0 1.4 0.4 0.4 1 0.4 1.4 0l9.9-9.9c0.4-0.4 0.4-1 0-1.4C25.3 14 24.6 14 24.2 14.3z"
      />
    </motion.svg>
  );
};

export default styled(CloseIcon)`
  cursor: pointer;
  width: ${(props) => (props.size ? props.size : 40)}px;
`;
